import React, { useEffect, useState } from "react";
import Select from "react-select";
// import 'react-select/dist/react-select.css';
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { SearchFilterAPI } from "../../redux/slices/SearchFilterSlice";
import { services } from "../../constants/base";

const SearchFilterBanner = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.SearchFilterSlice?.loading);

  // GET USER CURRENT LOCATION
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [error, setError] = useState(null);

  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setSearchFilterFormData({
            ...searchFilterFormData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          setError(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getLocation();
  }, []);
  // GET USER CURRENT LOCATION

  const [selectedValue, setSelectedValue] = useState("Professional ratings");
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "5", label: "★★★★★" },
    { value: "4", label: "★★★★☆" },
    { value: "3", label: "★★★☆☆" },
  ];

  const handleSelect = (option) => {
    setSelectedValue(option.label);
    setIsOpen(false);
  };

  // FILTER SEARCH INPUT BOX
  const [selectedServices, setSelectedServices] = useState([]);

  // const services = [
  //   { value: "1", label: "Plumber" },
  //   { value: "2", label: "Electrician" },
  //   { value: "3", label: "Car Mechanic" },
  // ];

  const [searchFilterFormData, setSearchFilterFormData] = useState({
    name: null,
    start_price: null,
    end_price: null,
    radius: "all",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchFilterFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleServicesChange = (selected) => {
    setSearchFilterFormData((prevData) => ({
      ...prevData,
      name: selected,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const servicesNameArray = searchFilterFormData?.name?.map(
      (item, index) => item.label
    );
    const newSearchFilterFormData = {
      ...searchFilterFormData,
      name: servicesNameArray,
    };
    const res = await dispatch(SearchFilterAPI(newSearchFilterFormData));
    if (res?.payload?.status === 200) {
      // setSearchFilterFormData({
      //     name: [],
      //     start_price: "",
      //     end_price: "",
      //     radius: "",
      // })
      // getLocation();
    }
  };

  useEffect(() => {
    setSearchFilterFormData({
      name: null,
      start_price: null,
      end_price: null,
      radius: "all",
    })
  }, [])


  // FILTER SEARCH INPUT BOX

  return (
    <>
      <div className="search-filter-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="home-banner-text">
                <h1>Welcome to I-Sit</h1>
                <p className="common-text">Where Every Service Finds a Seat.</p>
              </div>
            </div>

            {/* {error ? (
                            <p style={{ color: 'red' }}>{error}</p>
                        ) : location.lat && location.lng ? (
                            <p>
                                Latitude: {location.lat}, Longitude: {location.lng}
                            </p>
                        ) : (
                            <p>Fetching location...</p>
                        )} */}

            <div className="col-md-12">
              <form action="" onSubmit={handleSubmit}>
                <div className="container-fluid p-0">
                  <div className="row justify-center-box">
                    <div className="col-md-9">
                      <Select
                        isMulti
                        name="name"
                        options={services}
                        value={searchFilterFormData.name}
                        onChange={handleServicesChange}
                        className="input-search-filter"
                        aria-label="Select the services"
                        placeholder="Select Services"
                      />
                    </div>

                    <div className="col-md-2"></div>

                    <div className="col-md-3">
                      <div className="service-rate-field">
                        <input
                          type="number"
                          name="start_price"
                          placeholder="Enter Starting Price"
                          className="input-search-filter"
                          value={searchFilterFormData.start_price}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="service-rate-field">
                        <input
                          type="number"
                          name="end_price"
                          placeholder="Enter End Price"
                          className="input-search-filter"
                          value={searchFilterFormData.end_price}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <select
                        className="form-select input-search-filter"
                        name="radius"
                        value={searchFilterFormData.radius}
                        onChange={handleInputChange}
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Distance from your location
                        </option>
                        <option value="8">8 Km</option>
                        <option value="12">12 Km</option>
                        <option value="all">All</option>
                      </select>
                    </div>

                    <div className="col-md-2">
                      <div className="submit-button-box">
                        <button
                          type="submit"
                          disabled={loading || !searchFilterFormData.radius}
                        >
                          {!loading ? (
                            "Find now"
                          ) : (
                            <i
                              style={{ fontSize: "22px" }}
                              className="fa-solid fa-spinner fa-spin"
                            ></i>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchFilterBanner;
